import { useSession } from "contexts/session";

const useCsrfToken = () => {
  const { csrf } = useSession();
  return csrf;
};
export default useCsrfToken;
